import React from "react";
import { useParams } from "react-router-dom";
import { endpoints } from "../../hooks/use-api";
import VerifyVoucher from "../Vouchers/VerifyVoucher"

const VisionTest = (props) => {
  const { identifier } = useParams();

  const onSuccess = (responseData, formData) => {
    if (responseData.valid) {
      window.location.href = responseData.url;
      return [true, ""];
    } else {
      const msg = responseData.message.length > 0 ? responseData.message : `Voucher number ${formData.voucherNumber} is not setup for vision test`;
      return [false, msg]
    }
  }  

  return (
    <VerifyVoucher
      title="Online Vision Test"
      endpointFn={() => endpoints.apply.visionTest(identifier)}
      onSuccess={onSuccess} />      
  );
};

export default VisionTest;
